import React from "react";
import Marquee from "react-fast-marquee";

import billiontech from "../Img/100BILLION_TECH_logo.png";
import magnify from "../Img/magnify_advisory.png";
import urban from "../Img/urban_testmaster.png";
import smarthotel from "../Img/smart_hotel.png";
import vyomikaa from "../Img/vyomikaa_foods.png";
import aky from "../Img/aky.png";

const bankLogos = [
  billiontech,
  magnify,
  urban,
  smarthotel,
  vyomikaa,
  aky,
];

const Associates = () => {
  return (
    <div className="loan-card-main" style={{ overflowX: "hidden", maxWidth: "89%", margin: "0 auto" }}>
      <h2 className="sections-title-smco">
        <span className="horizontal-line"></span>Our Clients
      </h2>
      {/* Wrapper to limit width and prevent overflow */}
      <div style={{ overflowX: "hidden", maxWidth: "100%", margin: "0 auto", marginTop:"30px" }}>
        <Marquee
          gradient={false}
          speed={40}
          pauseOnHover={true}
          className="bank-marquee"
        >
          {bankLogos.map((src, idx) => (
            <div key={idx} style={{ margin: "0 2rem", flexShrink: 0 }}>
              <img
                src={src}
                alt={`bank-${idx}`}
                style={{
                  maxWidth: "150px",
                  maxHeight: "60px",
                  objectFit: "contain",
                  transition: "filter 0.3s ease",
                }}
                onMouseOver={e => (e.currentTarget.style.filter = "none")}
                onMouseOut={e => (e.currentTarget.style.filter = "grayscale(100%)")}
              />
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default Associates;
